import React, { useState } from 'react';
import { Modal, Text, Button, TextInput } from '@/ui-kits';
import { Icon } from '@/ui-kits';
import { useDispatch, useSelector } from 'react-redux';
import { submitFeedbackAndRatingRequest } from '@/services/redux/slices/patientDashboardSlice';
import { patientDashboardLoadingStatus } from '@/services/redux/selectors';
import { formatName } from '@/utils/common_functions';

interface FeedbackAndRatingModalProps {
  isOpen: boolean;
  onClose: () => void;
  consultationId: number;
  doctorName: string;
  doctorSpecialization: string;
  doctorPhoto: string;
}

export const FeedbackAndRatingModal: React.FC<FeedbackAndRatingModalProps> = ({
  isOpen,
  onClose,
  consultationId,
  doctorName,
  doctorPhoto, doctorSpecialization
}) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const isloading = useSelector(patientDashboardLoadingStatus);
  const dispatch = useDispatch();

  const handleRatingClick = (selectedRating: number) => {
    setRating(selectedRating);
  };

  const handleSubmit = async () => {
    dispatch(submitFeedbackAndRatingRequest({ id: consultationId, rating, feedback }));
  };

  const handleClose = () => {
    setRating(0);
    setFeedback('');
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      className="rounded-xl justify-center flex flex-col items-center w-[90%] max-w-md px-6">
      <div className='relative flex justify-center self-stretch'>
        <Text variant='title' className="text-ui_blue">
          Feedback & Rating
        </Text>
        <button
          onClick={handleClose}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors absolute right-0">
          <Icon type="close" className="size-5" />
        </button>
      </div>

      <div className='size-48 mt-4 bg-[#CBEBFB] pt-4 rounded-lg'>
        <img
          src={doctorPhoto}
          alt={`Dr. ${doctorName}`}
          className="w-full h-full object-contain rounded-xl"
        />
      </div>
      <Text variant='title' className='text-ui_blue my-1'>Rate your experience with</Text>
      <Text variant='subtitle' className='break-words my-1 text-center gradient-text'>Dr. {formatName(doctorName)} ({formatName(doctorSpecialization)})</Text>

      <div className="mb-6">
        <div className="flex justify-center gap-2 mb-2">
          {[1, 2, 3, 4, 5].map(star => (
            <button
              key={star}
              onClick={() => handleRatingClick(star)}
              className={`p-2 rounded-lg transition-colors`}>
              <Icon type={star <= rating ? 'star_yellow' : 'star_grey'} className="size-8" />
            </button>
          ))}
        </div>
      </div>
      <TextInput value={feedback} onChangeText={setFeedback} label='Feedback' multiline className='self-stretch' placeholder='Write your Review'/>
      <Button title="Submit Feedback" disabled={!(rating && feedback)} className='w-full mt-4 max-w-[300px]' onClick={handleSubmit}/>
    </Modal>
  );
};